module.exports = __webpack_public_path__ + "img/Cuidarte-purple.d4c4788f.svg";